/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { NBCall } from '../../../bridges/nebula/index.js';
import { E as ErrorCodes, a as ErrorMsgs } from '../../../constants-163bd007.js';
import '../../../index.es-142c5680.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function scan(params) {
    var formatInput = function (_a) {
        var _b = _a.scanType, scanType = _b === void 0 ? ['qrCode', 'barCode'] : _b, _c = _a.hideAlbum, hideAlbum = _c === void 0 ? false : _c;
        return ({
            scanType: scanType,
            hideAlbum: hideAlbum,
        });
    };
    var errFormatOutput = function (err) {
        var errMsg = (err === null || err === void 0 ? void 0 : err.error) === ErrorCodes.ErrScanUserCancel
            ? ErrorMsgs.ErrMsgCancel
            : ErrorMsgs.ErrMsgCommon;
        return {
            errMsg: errMsg,
        };
    };
    // https://smallfish.antfin-inc.com/jsapi/scan.html
    NBCall('scan', params, {
        formatInput: formatInput,
        formatOutput: function (res) { return ({
            // code数据为统一值
            code: (res === null || res === void 0 ? void 0 : res.qrCode) || (res === null || res === void 0 ? void 0 : res.barCode) || '',
        }); },
    }, { formatOutput: errFormatOutput });
}

export { scan as default };
